<template>
    <b-modal content-class="argus-glass-dialog"
        v-model="show"
        title="Возврат на доработку"
        @ok="handleOk"
        @cancel="handleCancel"
        :ok-disabled="!isValid || loading"
        :cancel-disabled="loading"
        ok-title="Вернуть на доработку"
        ok-variant="warning"
        cancel-title="Отмена"
        cancel-variant="outline-secondary"
        size="lg"
        scrollable
    >
        <div>
            <b-alert variant="warning" show class="mb-3">
                <i class="fas fa-exclamation-triangle mr-2"></i>
                <strong>Внимание!</strong> Заявка будет возвращена инициатору с возможностью редактирования.
            </b-alert>

            <b-form-group 
                label="Причина возврата:" 
                label-for="return-comment"
                :invalid-feedback="'Укажите причину возврата'"
                :state="isValid ? null : false"
            >
                <DiscussionEditor
                    id="return-comment"
                    v-model="comment"
                    placeholder="Укажите причину возврата заявки на доработку..."
                    :disabled="loading"
                    :state="isValid ? null : false"
                    required
                />
                <small class="form-text text-muted">
                    Комментарий обязателен и будет сохранен в истории заявки
                </small>
            </b-form-group>
        </div>
        
        <template #modal-footer="{ ok, cancel }">
            <b-button variant="outline-secondary" @click="cancel" :disabled="loading">
                Отмена
            </b-button>
            <b-button 
                variant="warning" 
                @click="ok" 
                :disabled="!isValid || loading"
            >
                <b-spinner v-if="loading" small class="mr-1"></b-spinner>
                {{ loading ? 'Возврат...' : 'Вернуть на доработку' }}
            </b-button>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: 'ReturnModal',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            comment: ''
        };
    },
    computed: {
        show: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        isValid() {
            return this.comment && this.comment.trim().length > 0;
        }
    },
    watch: {
        value(newVal) {
            if (!newVal) {
                this.comment = '';
            }
        }
    },
    methods: {
        handleOk() {
            if (!this.isValid) {
                return;
            }
            this.$emit('confirm', this.comment.trim());
        },
        handleCancel() {
            this.$emit('input', false);
            this.comment = '';
        }
    }
};
</script>
